import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
import "./propview.css"
function Propview(){
    return(
        <>
        <div className="propview">
             <div className="start">
                <h4>Propsal View </h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="information">
  <div className="from">
    <h4>From</h4>

    <p><strong>Name:</strong> Omar Rehan</p>
    <p><strong>Phone:</strong> +20 10 1234 5678</p>
    <p><strong>Email:</strong> omar.rehan.dev@gmail.com</p>
    <p><strong>Address:</strong> Cairo, Egypt</p>

    <div className="icons">
      <a href="#"><i className="fab fa-github"></i></a>
      <a href="#"><i className="fab fa-linkedin"></i></a>
    </div>
  </div>

  <div className="to">
    <h4>To</h4>

    <p><strong>Proposal:</strong> E-commerce Website Development</p>
    <p><strong>Due Date:</strong> 15 March 2026</p>
    <p><strong>Client Phone:</strong> +20 11 9876 5432</p>
    <p><strong>Client Email:</strong> client@example.com</p>
    <p><strong>Client Address:</strong> Alexandria, Egypt</p>
  </div>
</div>

        </div>
        <div className="services">
            <div className="start">
                <h4>Propsal Services </h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
           <div className="row g-4 m-2">

  <div className="col-md-4">
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        <i class="fa-solid fa-compass-drafting"></i>
        <h5 className="card-title">Web Design & Development</h5>
        <h6 className="card-subtitle mb-2 text-muted">Modern & Scalable Solutions</h6>
        <p className="card-text">
          I build responsive and user-friendly websites using HTML, CSS, 
          JavaScript, Bootstrap, and React. Clean code, performance optimization, 
          and modern UI/UX principles are always my priority.
        </p>
        <a href="#" className="card-link">View Projects</a>
        <a href="#" className="card-link">Contact Me</a>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        <i class="fa-solid fa-mobile"></i>
        <h5 className="card-title">Mobile Application Development</h5>
        <h6 className="card-subtitle mb-2 text-muted">Cross-Platform Apps</h6>
        <p className="card-text">
          Developing high-performance mobile applications using Flutter. 
          Clean architecture, smooth UI, and seamless user experience 
          across Android and iOS platforms.
        </p>
        <a href="#" className="card-link">See Apps</a>
        <a href="#" className="card-link">Get Quote</a>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        <i class="fa-solid fa-tv"></i>
        <h5 className="card-title">Cyber Security</h5>
        <h6 className="card-subtitle mb-2 text-muted">Secure & Protected Systems</h6>
        <p className="card-text">
          Implementing secure authentication systems, protecting data, 
          and applying best practices in web security to ensure safe 
          and reliable digital experiences.
        </p>
        <a href="#" className="card-link">Learn More</a>
        <a href="#" className="card-link">Security Tips</a>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        <i class="fa-solid fa-laptop"></i>
        <h5 className="card-title">Responsive Web Design</h5>
        <h6 className="card-subtitle mb-2 text-muted">Mobile-First Approach</h6>
        <p className="card-text">
          Creating fully responsive websites that adapt perfectly to all 
          screen sizes using Bootstrap, Flexbox, and modern CSS techniques.
        </p>
        <a href="#" className="card-link">Live Demo</a>
        <a href="#" className="card-link">Documentation</a>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="card h-100 shadow-sm">
      <div className="card-body">
        <i class="fa-solid fa-tv"></i>
        <h5 className="card-title">Frontend Development with React</h5>
        <h6 className="card-subtitle mb-2 text-muted">Interactive UI</h6>
        <p className="card-text">
          Building dynamic and interactive web applications using React, 
          Redux Toolkit, APIs integration, and modern development workflows.
        </p>
        <a href="#" className="card-link">GitHub</a>
        <a href="#" className="card-link">Portfolio</a>
      </div>
    </div>
  </div>

</div>


        </div>
        <div className="faqs">
             <div className="start">
                <h4>Propsal Faqs </h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
          <div className="somefaqs m-4">
  <div className="accordion" id="accordionExample">

    {/* 1 */}
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          Can I Change My Package?
        </button>
      </h2>
      <div
        id="collapseOne"
        className="accordion-collapse collapse show"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          Yes, you can upgrade or downgrade your package at any time.
          Changes will take effect immediately, and billing adjustments
          will be calculated automatically.
        </div>
      </div>
    </div>

    {/* 2 */}
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded="false"
          aria-controls="collapseTwo"
        >
          Are Packages and Prices Based on Location or Currency?
        </button>
      </h2>
      <div
        id="collapseTwo"
        className="accordion-collapse collapse"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          Our pricing is standardized globally. However, currency
          conversion may apply depending on your payment method
          and country.
        </div>
      </div>
    </div>

    {/* 3 */}
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseThree"
          aria-expanded="false"
          aria-controls="collapseThree"
        >
          What Payment Options Are Available?
        </button>
      </h2>
      <div
        id="collapseThree"
        className="accordion-collapse collapse"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          We accept credit cards, debit cards, and secure online
          payment gateways. All transactions are encrypted and protected.
        </div>
      </div>
    </div>

    {/* 4 */}
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseFour"
          aria-expanded="false"
          aria-controls="collapseFour"
        >
          How Can I Add Members When Creating a Schedule?
        </button>
      </h2>
      <div
        id="collapseFour"
        className="accordion-collapse collapse"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          When creating a schedule, simply select team members from
          your contact list. You can assign roles, permissions,
          and deadlines easily.
        </div>
      </div>
    </div>

    {/* 5 */}
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseFive"
          aria-expanded="false"
          aria-controls="collapseFive"
        >
          How Do I Create a Schedule and Add Reminders?
        </button>
      </h2>
      <div
        id="collapseFive"
        className="accordion-collapse collapse"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          Go to the scheduling section, choose date and time,
          then enable reminders. Notifications can be sent via
          email or in-app alerts.
        </div>
      </div>
    </div>

    {/* 6 */}
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseSix"
          aria-expanded="false"
          aria-controls="collapseSix"
        >
          How Can I Manage Tasks and Projects?
        </button>
      </h2>
      <div
        id="collapseSix"
        className="accordion-collapse collapse"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          You can create projects, assign tasks to team members,
          track progress, and monitor deadlines using the dashboard.
          Everything is organized in one place.
        </div>
      </div>
    </div>

  </div>
</div>


        </div>
        <div className="tasks">
             <div className="start">
                <h4>Propsal Tasks </h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
         <div className="task mt-4 p-4  rounded ">
  <div className="row">
    <div className="col-md-6">

      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="mb-0">Task Description</h4>
      </div>

      <div className="text">

        <p>
          This task focuses on developing a responsive and user-friendly 
          dashboard interface for managing projects and team activities.
        </p>

        <h6><strong>Project Name:</strong> Admin Dashboard System</h6>
        <h6><strong>Priority:</strong> High</h6>
        <h6><strong>Status:</strong> In Progress</h6>
        <h6><strong>Start Date:</strong> 01 February 2026</h6>
        <h6><strong>Due Date:</strong> 15 February 2026</h6>
        <h6><strong>Assigned To:</strong> Frontend Team</h6>
        <h6><strong>Technologies:</strong> React, Bootstrap, API Integration</h6>
        <h6><strong>Estimated Time:</strong> 20 Hours</h6>

      </div>

    </div>
   <div className="col-md-6">
  <div className="p-4  shadow-sm rounded">

    <h5 className="mb-4">Task Information</h5>

    <div className="mb-3">
      <strong>Task ID:</strong>
      <span className="ms-2 ">#TASK-2026-01</span>
    </div>

    <div className="mb-3">
      <strong>Status:</strong>
      <span className="badge bg-warning ms-2">In Progress</span>
    </div>

    <div className="mb-3">
      <strong>Priority:</strong>
      <span className="badge bg-danger ms-2">High</span>
    </div>

    <div className="mb-3">
      <strong>Start Date:</strong>
      <span className="ms-2">01 February 2026</span>
    </div>

    <div className="mb-3">
      <strong>Billable:</strong>
      <span className="badge bg-success ms-2">Yes</span>
    </div>

    <div className="mb-3">
      <strong>Amount:</strong>
      <span className="ms-2 ">$1,200</span>
    </div>

    <div className="mb-3">
      <strong>Logged Hours:</strong>
      <span className="ms-2 ">12h / 20h</span>
    </div>

    <div className="mb-3">
      <strong>Reminders:</strong>
      <span className="ms-2">2 Active</span>
    </div>

  </div>
</div>
 <div className="col-md-6">
    <div className="p-4  shadow-sm rounded">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Checklist</h5>
        <span className="badge bg-primary">3 / 5 Completed</span>
      </div>

      <div className="progress mb-4" style={{ height: "8px" }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: "60%" }}
        ></div>
      </div>

      <div className="form-check mb-2">
        <input className="form-check-input" type="checkbox" checked readOnly />
        <label className="form-check-label text-decoration-line-through">
          Design Wireframe
        </label>
      </div>

      <div className="form-check mb-2">
        <input className="form-check-input" type="checkbox" checked readOnly />
        <label className="form-check-label text-decoration-line-through">
          Setup Project Structure
        </label>
      </div>

      <div className="form-check mb-2">
        <input className="form-check-input" type="checkbox" checked readOnly />
        <label className="form-check-label text-decoration-line-through">
          API Integration
        </label>
      </div>

      <div className="form-check mb-2">
        <input className="form-check-input" type="checkbox" />
        <label className="form-check-label">
          Testing & Debugging
        </label>
      </div>

      <div className="form-check">
        <input className="form-check-input" type="checkbox" />
        <label className="form-check-label">
          Deployment
        </label>
      </div>

    </div>
  </div>
   <div className="col-md-6">
    <div className="p-4  shadow-sm rounded">

      <h5 className="mb-4">Tags</h5>

      <div className="d-flex flex-wrap gap-2">

        <span className="badge bg-primary">React</span>
        <span className="badge bg-success">Frontend</span>
        <span className="badge bg-warning text-dark">High Priority</span>
        <span className="badge bg-info text-dark">UI/UX</span>
        <span className="badge bg-secondary">API</span>
        <span className="badge bg-dark">Dashboard</span>

      </div>

    </div>
  </div>
  <div className="col-md-6">
    
  <div className="col-md-6">
    <div className="p-4  shadow-sm rounded h-100">
      <h5 className="mb-3">Topics</h5>

      <div className="d-flex flex-wrap gap-2">
        <span className="badge bg-primary">UI Design</span>
        <span className="badge bg-info text-dark">Frontend</span>
        <span className="badge bg-success">Optimization</span>
        <span className="badge bg-warning text-dark">Bug Fix</span>
      </div>
    </div>
  </div>
  </div>
  <div className="col-md-6 ">
    <div className="p-4  shadow-sm rounded h-100">
      <h5 className="mb-3">Assignees</h5>

      <div className="d-flex align-items-center mb-2">
        <img
          src="https://i.pravatar.cc/30?img=1"
          alt="user"
          className="rounded-circle me-2"
        />
        <span>Omar Rehan</span>
      </div>

      <div className="d-flex align-items-center mb-2">
        <img
          src="https://i.pravatar.cc/30?img=2"
          alt="user"
          className="rounded-circle me-2"
        />
        <span>Sarah Ahmed</span>
      </div>

      <div className="d-flex align-items-center">
        <img
          src="https://i.pravatar.cc/30?img=3"
          alt="user"
          className="rounded-circle me-2"
        />
        <span>Mohamed Ali</span>
      </div>
    </div>
  </div>
  <div className="col-md-6 ">
    <div className="p-4  shadow-sm rounded h-100">
      <h5 className="mb-3">Subject</h5>

      <p >
        Develop and finalize the Admin Dashboard interface
        with full task management features and responsive layout.
      </p>
    </div>
  </div>
  <div className="col-md-6 ">
    <div className="p-4  shadow-sm rounded h-100">
      <h5 className="mb-3">Followers</h5>

      <div className="d-flex align-items-center justify-content-between mb-3">
        <span >Total Followers</span>
        <strong>8</strong>
      </div>

      <div className="d-flex">
        <img src="https://i.pravatar.cc/35?img=4" className="rounded-circle me-2" />
        <img src="https://i.pravatar.cc/35?img=5" className="rounded-circle me-2" />
        <img src="https://i.pravatar.cc/35?img=6" className="rounded-circle me-2" />
        <img src="https://i.pravatar.cc/35?img=7" className="rounded-circle me-2" />
      </div>
    </div>
  </div>

  </div>
</div>

        </div>
        <div className="notes">
         <div className="start">
                <h4>Propsal Notes </h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="message">
              <textarea name="" placeholder="Enter Message" id=""></textarea>
              <button className="btn btn-dark m-2 w-100">Add Notes</button>
            </div>
            <hr />
            <div className="note">
              <div className="row">
                <div className="col-md-6">
  <div className="note-img">
    <div className="image">
      <img src={personone} alt="" />
    </div>
    <div className="text">
      <h5>Omar Hassan</h5>
      <h6>2024-01-10 09:15:22</h6>
      <p>Meeting about project requirements.</p>
    </div>
  </div>
</div>

<div className="col-md-6">
  <div className="note-img">
    <div className="image">
      <img src={persontwo} alt="" />
    </div>
    <div className="text">
      <h5>Sara Mohamed</h5>
      <h6>2024-02-18 11:40:12</h6>
      <p>Updated the dashboard UI design.</p>
    </div>
  </div>
</div>

<div className="col-md-6">
  <div className="note-img">
    <div className="image">
      <img src={personthree} alt="" />
    </div>
    <div className="text">
      <h5>Ahmed Khaled</h5>
      <h6>2024-03-05 16:22:48</h6>
      <p>Fixed login authentication issue.</p>
    </div>
  </div>
</div>

<div className="col-md-6">
  <div className="note-img">
    <div className="image">
      <img src={personfour} alt="" />
    </div>
    <div className="text">
      <h5>Laila Mostafa</h5>
      <h6>2024-04-12 13:05:30</h6>
      <p>Added new features to the exam system.</p>
    </div>
  </div>
</div>

<div className="col-md-6">
  <div className="note-img">
    <div className="image">
      <img src={personfive} alt="" />
    </div>
    <div className="text">
      <h5>Mahmoud Adel</h5>
      <h6>2024-05-21 18:47:09</h6>
      <p>Database performance optimization completed.</p>
    </div>
  </div>
</div>

              </div>
            </div>
        </div>
        </>
    )
}
export default Propview